// ----------------------------------------------------------------------------
// Template: Collection
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import '../../sections/header/header';
import '../../snippets/breadcrumbs/breadcrumbs';
import '../../snippets/card/card';
import '../../snippets/pagination/pagination';

import '../../sections/page-header/page-header';
import '../../sections/collection-driver/collection-driver';
import '../../sections/powertools-filter/powertools-filter';
import '../../sections/footer/footer';


// Styles
import './_collection.scss';
